/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/shareable_preview" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdShareablePreviewCacheKeys } from "./constants";
import type { EngagementShareablePreviewGetLinksProps, EngagementAppGroupIdShareablePreviewResult } from "./types";

export const getEngagementAppGroupIdShareablePreviewLinks = reactQueryFetcherAdapter(
  engagementAppGroupIdShareablePreviewCacheKeys,
  (
    signal: AbortSignal,
    { appGroupId, contextId }: EngagementShareablePreviewGetLinksProps
  ): Promise<EngagementAppGroupIdShareablePreviewResult> => {
    return fetchShareablePreviewLinks({ appGroupId, contextId });
  }
);

const fetchShareablePreviewLinks = ({
  appGroupId,
  contextId,
}: Omit<
  EngagementShareablePreviewGetLinksProps,
  "enableQuery"
>): Promise<EngagementAppGroupIdShareablePreviewResult> => {
  return fetch(`/engagement/${appGroupId}/shareable_preview/${contextId}`, "GET", undefined, {});
};
